/**
 * Mobile banner: flechas sobre el carril swipe-mobile (scroll nativo, sin Swiper).
 */
(function () {
  function scrollStep(scroller) {
    const inner = scroller.querySelector('.swipe-mobile__inner');
    const first = inner?.firstElementChild;
    if (!first) return Math.round(scroller.clientWidth * 0.85);
    const gap = inner ? parseFloat(window.getComputedStyle(inner).columnGap || '0') || 0 : 0;
    return first.getBoundingClientRect().width + gap;
  }

  function syncDisabled(scroller, prev, next) {
    const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth - 2);
    if (prev) {
      if (scroller.scrollLeft <= 2) prev.setAttribute('disabled', '');
      else prev.removeAttribute('disabled');
    }
    if (next) {
      if (scroller.scrollLeft >= max) next.setAttribute('disabled', '');
      else next.removeAttribute('disabled');
    }
  }

  function init(root) {
    const scroller = root.querySelector('.swipe-mobile');
    if (!scroller) return;

    const prev = root.querySelector('[data-wim-banner-scroll="prev"]');
    const next = root.querySelector('[data-wim-banner-scroll="next"]');

    const onScroll = () => syncDisabled(scroller, prev, next);

    prev?.addEventListener('click', () => {
      scroller.scrollBy({ left: -scrollStep(scroller), behavior: 'smooth' });
    });
    next?.addEventListener('click', () => {
      scroller.scrollBy({ left: scrollStep(scroller), behavior: 'smooth' });
    });

    scroller.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  document.querySelectorAll('[data-wim-banner-mobile]').forEach(init);

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target?.querySelector?.('[data-wim-banner-mobile]');
    if (root) init(root);
  });
})();
